import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RxIconModule } from '@nrwl/rx-icon';

@Component({
  selector: 'nrwl-rx-busy',
  templateUrl: './rx-busy.component.html',
  styleUrls: ['./rx-busy.component.scss'],
  imports: [CommonModule, FormsModule, RxIconModule],
})
export class RxBusyComponent implements OnInit {
  constructor() {}

  public ngOnInit() {}
}
